<!-- 我要报名 -->
<template>
  <div class="button">
    <div @click.stop="signUp(item)">
      <img src="@/assets/hideBox/baoming.png" alt />
      <span>我要报名</span>
    </div>
    <el-dialog
      class="gdryEdit-page"
      v-if="sendtype"
      :visible.sync="sendtype"
      title="报名信息"
      width="1200px"
      :append-to-body="true"
      :before-close="cancle"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        :model="personForm"
        label-width="125px"
        ref="personForm"
        class="form2"
        :rules="projectpersonForm"
      >
        <div>
          <el-row>
            <el-col :span="24" class="gdryup-avatar">
              <el-form-item label="本人头像">
                <div style="display: flex">
                  <img
                    v-if="personForm.pic"
                    :src="personForm.pic"
                    class="avatar"
                  />
                  <el-upload
                    class="avatar-uploader"
                    :http-request="uploadRequest"
                    :action="actionsUrl"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                  >
                    <div class="uploadimg">
                      <i class="el-icon-plus"></i>
                      <span>上传头像</span>
                    </div>
                  </el-upload>
                </div>
                <div class="text">
                  图片≤10MB，支持格式：bmp .png .jpg .jpeg
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-top: 90px">
            <el-col :span="12">
              <el-form-item label="姓名" prop="userName">
                <el-input
                  maxlength="10"
                  v-model="personForm.userName"
                  autocomplete="off"
                  placeholder="请输入报名人姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="userPhone">
                <el-input
                  maxlength="11"
                  v-model="personForm.userPhone"
                  autocomplete="off"
                  placeholder="请输入报名人联系电话"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工龄" prop="workYear">
                <el-input
                  width="395px"
                  type="tel"
                  maxlength="2"
                  v-model.number.trim="personForm.workYear"
                  autocomplete="off"
                  placeholder="请输入工龄"
                >
                  <template slot="append">年</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工程专业" prop="workType">
                <el-cascader
                  v-model="personForm.workType"
                  disabled
                  :show-all-levels="true"
                  :props="{expandTrigger: 'hover',label: 'name',value: 'no'}"
                  :options="industryList"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工种" prop="workNo">
                <el-select
                  v-model="personForm.workNo"
                  disabled
                >
                  <el-option
                    v-for="item in workTypeList"
                    :key="item.no"
                    :label="item.name"
                    :value="item.no"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="职级" prop="proficiency">
                <el-select
                  v-model="personForm.proficiency"
                  placeholder="请选择专业职级"
                >
                  <el-option
                    v-for="(item, index) in proficiency"
                    :key="index"
                    :label="item.desc"
                    :value="item.type"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所在地区" prop="address">
                <el-input
                  v-model="personForm.address"
                  autocomplete="off"
                  placeholder="请选择所在地区"
                  @focus="$refs.addressSeclect.IsShowMap = true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="remark">
                <el-input
                  class="remarks"
                  maxlength="50"
                  show-word-limit
                  v-model="personForm.remark"
                  autocomplete="off"
                  placeholder="请输入备注内容"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <el-col :span="24" class="footer">
        <el-button @click="cancle" class="cancel-btn">取消</el-button>
        <el-button @click="send" class="tijiao">确认报名</el-button>
      </el-col>
    </el-dialog>
    <!-- 地图选点 -->
    <AddressSeclect
      :addressObj="addressObj"
      ref="addressSeclect"
      @AddressObj="loadingAddressObj"
      @getAllAddress="v => {personForm.address = v}"
    ></AddressSeclect>
  </div>
</template>

<script>
import {apiResignAll} from "@/api/apiResignAll"
import {apiFlexibleEmployment} from "@/api/apiFlexibleEmployment"
import {checkDataStatusMessage} from "@/utils/checkDataStatus"
import { customUpload } from "@/utils/customUpload"
import request from "@/http"
export default {
  name: "signNameMy",
  inject:['cardListCom'],
  props:{
    item: {
      type: Object
    },
  },
  components: {
    AddressSeclect: () => import("@/public/Map/AddressSeclect.vue") //地图选点
  },
  data() {
    return {
      sendtype: false,
      IsShowMap: false,
      actionsUrl: "",
      proficiency: [
        {
          type: 3,
          desc: "初级工(小工)"
        },
        {
          type: 2,
          desc: "中级工(中工)"
        },
        {
          type: 1,
          desc: "高级工(大工)"
        }
      ],
      //请求参数
      personForm: {
        pic: require("../../../assets/public/gongren.png"),
        userName: "",
        userPhone: "",
        workYear: null,
        workType: [],
        workNo: [],
        proficiency: "",
        address: "",
        remark: "",
        longitude: "",
        latitude: "",
        provinceNo: "",
        cityNo: "",
        areaNo: "",
        provinceName: "",
        cityName: "",
        areaName: "",
        industryNo: "",
        categoryNo: "",
        createUserNo: "",
      },
      industryList: [],
      workTypeList: [],
      //所在地区选择地图数据
      addressObj: {
        address: "",
        lng: null,
        lat: null
      },
      projectpersonForm: {
        userName: [{ required: true, trigger: "blur", message: "请输入报名人姓名" }],
        userPhone: [{ required: true, trigger: "blur", validator: this.validPhone }],
        workType: [{ required: true, trigger: "change", message: "请选择工程专业" }],
        workNo: [{ required: true, trigger: "change", message: "请选择工种" }],
        proficiency: [{ required: true, trigger: "change", message: "请选择职级" }],
        workYear: [{ required: true, trigger: "blur", validator: this.validWorkyear }],
        address: [{ required: true, trigger: "change", message: "请选择所在地区" }]
      },
    }
  },
  methods: {
    //验证电话号码
    validPhone(rule, value, callback) {
      if (!value) {
        callback("请输入报名人联系电话")
      } else {
        //手机号码验证regEx:第一位数字必须是1，11位数字
        var reguPhone =/^((13[0-9])|(14[0,5,6,7,9])|(15([0-3]|[5-9]))|(16([6,7]))|(17([1-3]|[5-8]))|(18[0-9])|(19[1,3,5,8,9]))\d{8}$/
        var rePhone = new RegExp(reguPhone)
        if (rePhone.test(value)) {
          callback()
        } else {
          var regularEx = /^0\d{2,3}-\d{7,8}$/
          var reTel = new RegExp(regularEx)
          if (reTel.test(value)) {
            callback()
          } else {
            callback("联系电话不正确")
          }
        }
      }
    },
    validWorkyear(rule, value, callback) {
      if (!value&&value!==0) {
        callback("请输入工龄")
      }else if(value===0){
        callback("工龄不能为0")
      } else {
          var regularEx = /^(0|[1-9][0-9]*)$/
          var reTel = new RegExp(regularEx)
          if (reTel.test(value)) {
            callback()
          } else {
            callback("请输入数字")
        }
      }
    },
    uploadRequest(params) {
      customUpload(params)
    },
    //上传个人图片成功后回调
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.personForm.pic = res.data[0].uuid
      } else {
        this.$message.error("上传失败，请重新上传！")
      }
    },
    //上传个人图片前验证合法性
    beforeAvatarUpload(file) {
      const isJPG1 = file.type === "image/jpeg"
      const isJPG2 = file.type === "image/png"
      const isJPG3 = file.type === "image/jpg"
      const isJPG4 = file.type === "image/bmp"
      // const isJPG5 = file.type === "image/gif"
      const isLt2M = file.size / 1024 / 1024 <= 10
      if (!(isJPG1 || isJPG2 || isJPG3 || isJPG4 )) {
        this.$message.error("上传的图片格式不支持，请上传.bmp .png .jpg .jpeg格式")
        return false
      }
      if (!isLt2M) {
        this.fullscreenLoading = false
        this.$message.error("图片大小不能超过10MB")
        return false
      }
      return (isJPG1 || isJPG2 || isJPG3 || isJPG4 || isJPG5) && isLt2M
    },
    //选择所在地区后地图选点
    loadingAddressObj(obj) {
      const reg1 = new RegExp("市")
      this.personForm.longitude = obj.addressObj.lng
      this.personForm.latitude = obj.addressObj.lat
      this.personForm.provinceNo = obj.PriData.provinceNo
      this.personForm.cityNo = obj.PriData.cityNo
      this.personForm.areaNo = obj.PriData.districtNo
      this.personForm.provinceName =obj.PriData.province === "北京市" || "上海市" || "天津市" || "重庆市"? obj.PriData.province.replace(reg1, ""): obj.PriData.province
      this.personForm.cityName = obj.PriData.city
      this.personForm.areaName = obj.PriData.district
    },
    //立即报名
    async signUp() {
      if(this.permissionTips({
        type:['person']
      })) return

      let no = this.item.no
      if(this.$parent.type==2){
        no = this.item.companyNo
      }
      const dataState = await checkDataStatusMessage.call(this,this.$parent.type,no)
      if(!dataState || dataState!=1){
        return
      }


      
      //登录状态检查
      let userAuthority = this.$store.state.authUser.authority
      if(userAuthority.includes('ROLE_member') && userAuthority.length>1){
        return this.$message({ message:'请前往用户中心将身份切换为个人才可报名', type: "error" })
      }
      // 获取用户信息
      let user=this.$store.state.user;
      if(!user.imAccount){
        let data = {
          callBack: function() {
            this.$store.dispatch("setUser")
          }.bind(this)
        }
        this.$_login(data);
        return;
      }
      //发布人检查
      let state='';
      if(user.type==0){
        state=user.no==this.item.userNo?"操作失败，不能对自己发布的内容进行该操作":''
      }else if(user.type==1){
        state=user.companyNo==this.item.companyNo?"操作失败，不能对同企业发布的内容进行该操作":''
      }else if(user.type==2){
        state=user.teamNo==this.item.teamNo?"操作失败，不能对同团队发布的内容进行该操作":''
      }

      if(state){
        this.$message.error(state)
        return;
      }
      //查询招工状态
      let res = await apiResignAll.getIsEnable(this.item.no)
      if(res.data.code==200&&res.data.data.isEnable){
        //获取报名信息，准备报名
        res=await apiFlexibleEmployment.laborEmploymentIsApply(this.item.no)
        if(res.data.code==200){
          this.info=res.data.data;
          this.personForm.userName = this.$store.state.user.realName
          this.personForm.userPhone = this.$store.state.user.telPhone
          this.personForm.workNo = this.item.workNo
          this.personForm.workType = [this.item.industryNo, this.item.categoryNo]
          this.personForm.industryNo = this.item.industryNo
          this.personForm.categoryNo = this.item.categoryNo
          this.personForm.createUserNo = this.item.createUserNo
          this.getlevel3List(this.personForm.categoryNo)
          let result = await request.get(`${process.env.VUE_APP_APITEAM}/worker/userDetailWorker`)
          if (result.data.code === 200) {
            let oldData = result.data.data
            this.personForm.workYear = oldData.workYear? Number(oldData.workYear): null
            this.personForm.proficiency = oldData.proficiency? oldData.proficiency: ""
            this.personForm.provinceNo = oldData.provinceNo? oldData.provinceNo: ""
            this.personForm.cityNo = oldData.cityNo ? oldData.cityNo : ""
            this.personForm.areaNo = oldData.areaNo ? oldData.areaNo : ""
            this.personForm.provinceName = oldData.provinceName? oldData.provinceName: ""
            this.personForm.cityName = oldData.cityName ? oldData.cityName : ""
            this.personForm.areaName = oldData.areaName ? oldData.areaName : ""
            this.personForm.address = oldData.address? oldData.address: oldData.provinceName + oldData.cityName + oldData.areaName? oldData.provinceName + oldData.cityName + oldData.areaName: ""
            this.addressObj.address = oldData.address? oldData.address: oldData.provinceName + oldData.cityName + oldData.areaName? oldData.provinceName + oldData.cityName + oldData.areaName: ""
            this.addressObj.lng = oldData.longitude ? oldData.longitude : ""
            this.addressObj.lat = oldData.latitude ? oldData.latitude : ""
          }
          let resu = await request.get(`${process.env.VUE_APP_APITEAM}/service/industry/listSelect?type=1`)
          if (resu && resu.data.code == 200) {
            this.industryList = resu.data.data
          }
          this.sendtype=true;
        }else if(res.data.code==201){
          this.$confirm('劳务用工报名需要实名认证，是否前往实名认证？', '温馨提示', {
            confirmButtonText: '前往认证',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            window.open(`${process.env.VUE_APP_PERSONURL}/authenticationRealName`)
          })
        }else if(res.data.code==202){
          this.$message.error(res.data.msg)
        }else{
          this.$message.error(res.data.msg)
        }
      }else{
        this.$message.warning('该劳务用工已招满，请重新选择')
        this.$emit('getlist');
      }
    },
    //获取工种列表3级
    async getlevel3List(categoryNo) {
      let res = await request.get(`${process.env.VUE_APP_APITEAM}/occupationConfig/newList`,{categoryNo: categoryNo})
      if (res && res.data.code == 200) {
        this.workTypeList = res.data.data
      }
    },
    //取消按钮
    cancle() {
      this.sendtype = false
      this.personForm.pic=require("../../../assets/public/gongren.png")
      this.$refs.personForm.resetFields()
      this.$refs.personForm.clearValidate()
    },
    //确认报名按钮
    send() {
      this.$refs.personForm.validate(async valid => {
        if (valid) {
          // delete this.personForm.workType
          if (this.personForm.pic.includes("gongren")) {
            delete this.personForm.pic
          }
          delete this.personForm.longitude
          delete this.personForm.latitude
          this.personForm.relationNo = this.item.no
          apiFlexibleEmployment.laborEmploymentApply(this.personForm).then(res => {
              if (res.data.code == 200) {
                this.$message.showPermissionTips('报名成功',() => {},false,'知道了',true)
              } else {
                this.$message.error(res.data.msg)
              }
            }).finally(v=>{
              this.sendtype=false
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.gdryEdit-page {
  .gdryup-avatar {
    /deep/.el-form-item__content {
      line-height: 14px;
    }
    /deep/.avatar-uploader .el-upload {
      box-sizing: border-box;
      border: 1px dashed #e4e7ed;
      border-radius: 0;
      cursor: pointer;
      width: 100px;
      height: 100px;
      position: relative;
      overflow: hidden;
      margin-left: 10px;
    }
    .avatar {
      width: 100px;
      height: 100px;
      display: block;
      border-radius: 0;
      border: 1px dashed #e4e7ed;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .uploadimg {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 100px;
      height: 100px;
      .el-icon-plus {
        font-size: 24px;
        color: #0286df;
        margin-bottom: 10px;
      }
      span {
        color: #969696;
        font-size: 14px;
      }
    }
    .text {
      font-size: 14px;
      color: #969696;
      margin-top: 10px;
    }
    .dialog-footer {
      text-align: center;
    }
  }
  /deep/.el-dialog__header {
    padding: 0 15px !important;
    height: 44px;
    line-height: 44px;
    border-bottom: 1px solid #dfe4ea;
    .el-dialog__title {
      font-size: 18px;
      color: #000;
    }
    .el-dialog__headerbtn {
      top: 12px;
    }
  }
  .el-select {
    width: 450px;
  }
  .el-input {
    width: 450px;
  }
  .el-cascader {
    width: 450px;
  }
  /deep/.el-dialog__body {
    padding: 20px !important;
    height: 418px;
  }
  /deep/.el-input {
    height: 34px;
  }
  /deep/.el-input__inner {
    padding-left: 10px;
    height: 34px;
    line-height: 34px;
    color: #000;
  }
  /deep/.workyear {
    width: 195px !important;
  }
  /deep/.el-form-item {
    height: 34px;
    line-height: 34px;
    margin-bottom: 15px;
  }
  /deep/.el-form-item__content {
    line-height: 34px;
    height: 34px;
  }
  /deep/.el-cascader {
    line-height: 34px;
  }
  /deep/.el-form-item__error {
    padding-top: 1px;
  }
  /deep/.el-form-item__label {
    line-height: 34px;
    color: #333;
  }
  /deep/.el-input-group__append, .el-input-group__prepend{
    padding: 0 10px;
  }
  .remarks{
    width: 1030px;
  }
  .footer {
    text-align: center;
    /deep/ .el-button {
      padding: 9px 14px;
    }
    .cancel-btn {
      color: #969696;
      font-weight: normal;
      &:hover,
      &:focus {
        color: #0286df;
        border-color: #0286df;
        background: #fff;
      }
    }
    .tijiao {
      font-weight: normal;
      color: #fff;
      border-color: #0286df;
      background: #0286df;
      padding: 0 14px;
      height: 34px;
      line-height: 34px;
      text-align: center;
      font-size: 14px;
      margin-left: 15px;
      &:hover,
      &:focus {
        color: #fff;
        border-color: #0286df;
        background: #0286df;
      }
    }
  }
}
</style>